var audioElement = document.createElement('audio');

$('.podcast').on('click', function () {
  var pausing = false;
  if ($(this).hasClass('playing')) {
    audioElement.pause();
    pausing = true;
  }
  $('.playing').removeClass('playing');
  if (pausing == false) {
    $(this).addClass('playing');
    audioElement.setAttribute('src', $(this).data('audio'));
    audioElement.setAttribute('id', 'podcastplayer');
    audioElement.setAttribute('autoplay', 'autoplay');
    //audioElement.load()
    $.get();
    audioElement.addEventListener("load", function () {
      audioElement.play();
    }, true);
  }
});